import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";

@Component({
  selector: "app-ctrl-segment-exclude",
  templateUrl: "./ctrl-segment-exclude.component.html",
  styleUrls: ["./ctrl-segment-exclude.component.css"],
})
export class CtrlSegmentExcludeComponent implements OnChanges {
  @Input() survey: any;
  @Input() item: any;
  @Output() itemChanged = new EventEmitter();

  constructor() {}

  ngOnChanges(): void {}

  public onChangeExclude() {
    this.itemChanged.emit({ item: this.item });
  }
}
